import { useSelector } from 'react-redux';
import css from './styles.module.scss';
import { NewModal } from '../../../../../../components/ui/modals/new-modal';
import {
	templateTagsSettingsActions,
	templateTagsSettingsSlice,
} from '../../../../../../entities/template/private-template-tag-settings';
import { useAppDispatch } from '../../../../../../shared/libs/redux';
import {
	templateTagGroupSelectors,
} from '../../../../../../entities/template/private-template-tag-group/model/slice/privateTemplateTagGroupSlice';
import { templateTagSelectors } from '../../../../../../entities/template/private-template-tag/model/slice/templateTagSlice';
import { PrivateTemplateTagGroupSettings } from '../tag-group-settings/PrivateTemplateTagGroupSettings';

/**
 * Компонент - Модальное окно настройки тегов (группы тегов) приватных шаблонов
 */
export const PrivateTemplateTagSettingsModal = () => {
	const dispatch = useAppDispatch();

	const isActive = useSelector(templateTagsSettingsSlice.selectors.getIsTagsSettingsModalActive);
	const isCreateGroupModalActive = useSelector(templateTagGroupSelectors.getIsCreateGroupModalActive);
	const isDeleteGroupModalActive = useSelector(templateTagGroupSelectors.getIsDeleteGroupModalActive);
	const isDeleteTagModalActive = useSelector(templateTagSelectors.getIsDeleteTagModalActive);

	const handleModal = (value: boolean) => {
		dispatch(templateTagsSettingsActions.setIsTagsSettingsModalActive(value));
	};

	return (
		<NewModal
			active={isActive}
			closeFunc={handleModal}
			modalInModalActive={
				isCreateGroupModalActive
				|| isDeleteGroupModalActive
				|| isDeleteTagModalActive
			}
		>
			<div className={css.title}>
				Настройка тегов шаблонов
			</div>
			<PrivateTemplateTagGroupSettings />
		</NewModal>
	);
};
